// extracted by mini-css-extract-plugin
export var card = "_6o-0";
export var expandedCard = "_6o-2";
export var paginated = "_6o-1";